import {
  BrowseSubscriptionPlanRequest,
  BrowseSubscriptionPlanResponse,
  PlanInterval,
  SubscriptionStatus,
} from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { PLAN_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';

export function useBrowseSubscriptionPlanApi(interval?: PlanInterval) {
  return useBaseQuery<
    BrowseSubscriptionPlanRequest,
    BrowseSubscriptionPlanResponse
  >([useBrowseSubscriptionPlanApi.name, interval], {
    url: PLAN_ROOT_ENDPOINT,
    params: {
      status: SubscriptionStatus.ACTIVE,
      interval,
    },
  });
}
